import Workflows from './automation/workflows'
import Button from '@admin/components/button'
import Page from '@admin/components/page'
import Unsubscribes from './unsubscribes'
import Emails from './automation/emails'
import Performance from './performance'
import Activities from './activities'
import Deliveries from './deliveries'
import Complaints from './complaints'
import Overview from './overview'
import Bounces from './bounces'
import Unopens from './unopens'
import Sending from './sending'
import Replies from './replies'
import Design from './design'
import Unsent from './unsent'
import Links from './links'
import Opens from './opens'
import React from 'react'

const more = {
  label: 't(Learn more about our warmup process)',
  className: 'link',
  link: 'https://truevail.helpscoutdocs.com/article/97-understanding-our-new-email-warming-strategy'
}

const mapPropsToPage = (props, context, resources, page) => ({
  title: resources.email_campaign.title,
  manager: {
    path: `/admin/campaigns/email/${resources.email_campaign.id}`,
    alert: resources.email_campaign.status === 'warming' ? {
      style: 'warning',
      message: (
        <>Your campaign from { resources.email_campaign.sender.email } is currently in the warming process. This helps improve deliverability and open rates. Performance data will be incomplete until the warming process is finished.<br /><Button { ...more } /></>
      )
    } : null,
    items: [
      {
        label: 't(Overview)',
        panel: <Overview email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Design)',
        path: '/design',
        panel: <Design email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Automation)',
        access: { rights: { $allOf: ['automation:access_app'] } },
        children: [
          {
            label: 't(Workflows)',
            path: '/workflows',
            panel: <Workflows email_campaign={ resources.email_campaign } />
          },
          {
            label: 't(Emails)',
            path: '/emails',
            panel: <Emails email_campaign={ resources.email_campaign } />
          }
        ]
      },
      {
        label: 't(Sending)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/sending',
        panel: <Sending email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Activities)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/activities',
        panel: <Activities email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Bounces)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/bounces',
        panel: <Bounces email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Complaints)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/complaints',
        panel: <Complaints email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Deliveries)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/deliveries',
        panel: <Deliveries email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Links)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/links',
        panel: <Links email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Opens)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/opens',
        panel: <Opens email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Replies)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/replies',
        panel: <Replies email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Unopens)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/unopens',
        panel: <Unopens email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Unsent)',
        show: ['canceled'].includes(resources.email_campaign.status),
        path: '/deliveries',
        panel: <Unsent email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Unsubscribes)',
        show: ['sending','sent','canceled'].includes(resources.email_campaign.status),
        path: '/unsubscribes',
        panel: <Unsubscribes email_campaign={ resources.email_campaign } />
      },
      {
        label: 't(Performance)',
        show: resources.email_campaign.status === 'sent',
        path: '/performance',
        panel: <Performance email_campaign={ resources.email_campaign } />
      }
    ]
  }
})

const mapResourcesToPage = (props, context) => ({
  email_campaign: `/api/admin/campaigns/email/${props.params.id}`
})

export default Page(mapResourcesToPage, mapPropsToPage)
